module.exports = __webpack_public_path__ + "img/guide-img.43f83881.jpg";